"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
function normalizeApiUrl(url) {
    if (url === void 0) { url = ''; }
    if (url === '.' || url === '/' || !url) {
        return '';
    }
    return new URL(url).origin;
}
exports.default = normalizeApiUrl;
